/* eslint-disable react/style-prop-object */
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AccountFocused: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M20.882 7.14c-3.64 0-6.6 2.96-6.6 6.6 0 3.637 2.96 6.597 6.6 6.597 3.638 0 6.6-2.96 6.6-6.597 0-3.64-2.962-6.6-6.6-6.6m0 10.71a4.116 4.116 0 0 1-4.113-4.11 4.117 4.117 0 0 1 4.113-4.112 4.117 4.117 0 0 1 4.113 4.112 4.116 4.116 0 0 1-4.113 4.11"
                />
                <circle cx="20.88" cy="13.652" r="5.622" fill="#FFFFFF" />
                <path
                    fill="currentColor"
                    d="M20.882 0C9.368 0 0 9.368 0 20.882 0 32.395 9.368 41.76 20.882 41.76c11.513 0 20.878-9.365 20.878-20.878C41.76 9.368 32.395 0 20.882 0ZM32.69 35.05a17.392 17.392 0 0 1-11.808 4.616c-4.381 0-8.577-1.64-11.81-4.616l-.237-.219.076-.308a12.299 12.299 0 0 1 11.971-9.348c3.288 0 6.388 1.283 8.729 3.614a12.223 12.223 0 0 1 3.237 5.734l.077.308-.235.22Zm2.832-3.06-.57.752-.36-.874a14.788 14.788 0 0 0-3.23-4.838 14.714 14.714 0 0 0-10.48-4.342c-6.048 0-11.425 3.607-13.7 9.186l-.357.878-.576-.752a18.195 18.195 0 0 1-3.763-11.119c0-10.143 8.253-18.395 18.396-18.395s18.395 8.252 18.395 18.395a18.2 18.2 0 0 1-3.755 11.11Z"
                />
                <path
                    fill="#FFFFFF"
                    d="M32.69 35.051a17.392 17.392 0 0 1-11.808 4.616c-4.381 0-8.577-1.64-11.81-4.616l-.237-.219.076-.308a12.299 12.299 0 0 1 11.971-9.348c3.288 0 6.388 1.283 8.729 3.614a12.223 12.223 0 0 1 3.237 5.734l.077.308-.235.22Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(AccountFocused);
